/* eslint-disable react/style-prop-object */
import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import ViewTask from "./ViewTask/ViewTask";
import { useGetSingleTaskQuery } from "../../../Redux/service/Tasks/Tasks";
import { ConfigProvider, Tag, Tooltip } from "antd";
import Button from "../../Helpers/Button/Button";
import { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";

export function TaskPopup({ taskId, onClose }) {
	const { data, isFetching } = useGetSingleTaskQuery(taskId, {
		skip: !taskId,
		refetchOnMountOrArgChange: true,
	});
	const { handleShow } = useContext(popupcontext);

	const { edit: canEdit } = usePermission("FIELD_TASKS");
	const task = data?.data || "";

	const statusColors = {
		todo: `blue`,
		inProgress: `orange`,
		done: `green`,
		// delayed: `red`,
		unassigned: `default`,
	};

	const onEdit = () => {
		onClose();
		handleShow("editForm", "task", taskId);
	};
	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: "#0f6936",
					activeBg: "#0f6936",
					activeBorderColor: "#2e9245",
				},
			}}
		>
			<Popup show={!!taskId} size={"xl"}>
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={
								<div>
									{task.name || "Loading..."}{" "}
									{!isFetching && (
										<Tag
											color={
												statusColors[task.status] || statusColors.unassigned
											}
											className="text-capitalize"
										>
											{trans(task.status)}
										</Tag>
									)}
									{!isFetching && task?.isDelayed && (
										<Tooltip
											title={trans(
												"The actual start time was later than the scheduled start time"
											)}
										>
											<Tag color={"red"} className="text-capitalize">
												{trans("delayed")}
											</Tag>
										</Tooltip>
									)}
									{!isFetching && task.isOverDue && (
										<Tooltip
											title={trans("The work exceeded the estimated duration")}
										>
											<Tag color={"red-inverse"} className="text-capitalize">
												{trans("Over Due")}
											</Tag>
										</Tooltip>
									)}
								</div>
							}
							subtitle={`${task.code || ""}`}
						/>
					</Modal.Title>
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={onClose}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable fixed-popup-height">
					{isFetching ? (
						<div className="loader-container">
							<Loader />
						</div>
					) : (
						<ViewTask data={task} />
					)}
				</Modal.Body>
				<Modal.Footer>
					<div className="popups-footer gap-8">
						<>
							{canEdit && (
								<Button
									type="primary"
									text={trans("Edit task")}
									htmlType="submit"
									onClick={() => onEdit()}
								/>
							)}
							{/* <Button
                type={"default"}
                htmlType="button"
                text={trans("Reassign")}
                onClick={() => {}}
              /> */}
						</>
					</div>
				</Modal.Footer>
			</Popup>
		</ConfigProvider>
	);
}
